import { Splide } from '@splidejs/splide';

// Drupal behavior for the Partner Slider block
(function (Drupal) {
  Drupal.behaviors.partnerSlider = {
    attach(context: HTMLElement) {
      context.querySelectorAll<HTMLElement>('[data-partner-slider]').forEach((el) => {
        // Prevent double initialization
        if (el.classList.contains('is-initialized')) return;

        // Count items inside the slider
        const items = el.querySelectorAll('.splide__slide');
        if (items.length <= 9) {
          // Don't initialize Splide, just add "is-initialized"
          el.classList.add('is-initialized', 'slider-inactive');
          return;
        } else {
          el.classList.add('slider-active');
        }

        // Initialize Splide only if more than 9 items
        new Splide(el, {
          type: 'slide',
          perPage: 9,
          perMove: 1,
          autoplay: false,
          interval: 3000,
          gap: '1rem',
          pagination: false,
          arrows: true,
          breakpoints: {
            1280: { perPage: 7 },
            1024: { perPage: 5 },
            768: { perPage: 3 },
            480: { perPage: 2 },
          },
        }).mount();

        el.classList.add('is-initialized');
      });
    },
  };
})(Drupal as any);
